//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from '@/api/system/user/user';
import { fetchCreate, fetchUpdate, fetchDetail } from "@/api/PMS/communityPartyBuilding/outPersion";
export default {
  props: ['keyValue', 'showDialog', 'actiId'],
  data: function data() {
    return {
      rules: {
        userId: [{
          required: true,
          message: '请选择姓名',
          trigger: 'change'
        }] // mobilePhone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }, { min: 11, max: 11, message: '请输入11位手机号', trigger: 'change' }],

      },
      childData: {
        userId: '',
        // mobilePhone: '',
        actiId: ''
      },
      userOptions: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    getUser: function getUser() {
      var _this = this;

      fetchList({
        userState: 0,
        posId: 1777
      }).then(function (res) {
        _this.userOptions = res.data.data;
      });
    },
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });
      this.getUser();

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;
        });
      } else {
        this.childData = {
          userId: '',
          // mobilePhone: '',
          actiId: ''
        };
      }
    },
    handCreate: function handCreate() {
      var _this3 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this3.keyValue > 0) {
            fetchUpdate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'update'
                });
              }
            });
          } else {
            _this3.childData.actiId = _this3.actiId;
            fetchCreate(_this3.childData).then(function (res) {
              if (res.data.code == 200) {
                _this3.$emit('handCancle', true);

                _this3.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this3.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};